import React from 'react';
import { Box, Typography } from '@p81-common/ui';
import { createClasses } from './styles';

export interface BillingToggleLabels {
  migrationTitle: string;
  migrationBody: string;
}

interface BillingToggleSectionProps {
  labels: BillingToggleLabels;
}

const BillingToggleSection = ({ labels }: BillingToggleSectionProps) => {
  const classes = createClasses();

  return (
    <Box className={classes.container}>
      <Box className={classes.infoBox}>
        <Typography variant="body2" className={classes.infoTitle}>
          {labels.migrationTitle}
        </Typography>
        <Typography variant="body2" className={classes.infoBody}>
          {labels.migrationBody}
        </Typography>
      </Box>
    </Box>
  );
};

export default BillingToggleSection;
